import Navbar from "./layouts/Navbar";
import Home from "./pages/home";

function App() {
  return (
    <>
      <Navbar />
      <Home />
    </>
  );
}

export default App;





// import './App.css';
// import Home from "./pages/home";

// function App() {
//   return <Home />;
// }

// export default App;

